/**
 * Estimates the one-rep max (1RM) using the Epley formula for reps 2-10.
 * For 1 rep, returns the weight itself.
 *
 * @param weightLb The weight lifted in pounds. Must be a positive integer.
 * @param reps The number of reps performed. Must be an integer between 1 and 10.
 * @returns The estimated 1RM in pounds.
 */
export function estimateOneRepMax(weightLb: number, reps: number): number {
  if (!Number.isInteger(weightLb) || weightLb <= 0) {
    throw new Error('Weight must be a positive integer.');
  }
  if (!Number.isInteger(reps) || reps < 1 || reps > 10) {
    throw new Error('Reps must be an integer between 1 and 10.');
  }

  if (reps === 1) {
    return weightLb;
  }

  return weightLb * (1 + reps / 30);
}
